import React from "react";
import "./error_failover_handler.css"; // for styling
import { Button } from "pepsico-ds";

const ErrorFailOverHandler = ({ header, title, supportMessage, supportLabel, supportLink, alternateMessage, alternateLabel, alternateLink, image }) => {
  return (
    <div className="error_fail_over_handler">
      <div style={{ textAlign: "center" }}>
        <h4 className="error_header">{header || "Error"}</h4>

        <h6 className="error_title mt-4">{title || "Something went wrong"}</h6>

        {/* <p className="error_message">{message || "We couldn’t find the page you’re looking for."}</p> */}

        {supportLink && (
          <span className="d-flex" style={{ fontSize: "16px", alignItems: "center", justifyContent: "center", gap: "4px" }}>
            {supportMessage || "We couldn’t find the page you’re looking for."}
            <Button className="" size="medium" style={{}} text={supportLabel} variant="tertiary" onClick={() => {
              if (supportLink) {
                window.open(supportLink, "_blank");
              } else {
                window.location.href = `mailto:DL-IAMCentralDevelopment@pepsico.com?subject=Support Request&body=Hello Team,`;
              }
            }} />
          </span>
        )}

        {alternateLink && (
          <span className="d-flex mt-3" style={{ fontSize: "16px", alignItems: "center", justifyContent: "center", gap: "4px" }}>
            {alternateMessage || "We couldn’t find the page you’re looking for."}
            <Button className="" size="small" style={{}} text={alternateLabel} variant="secondary" onClick={() => window.open(alternateLink, "_blank")} />
          </span>
        )}

        {image && (
          <div className="error_fail_over mt-4">
            {/* <img src={image} alt="Error Illustration" /> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorFailOverHandler;
